import {
  LOAD_DRAFT,
  LOAD_DRAFT_EMPTY,
  LOAD_DRAFT_SUCCESS,
  LOAD_DRAFT_ERROR,
  SAVE_DRAFT,
  SAVE_DRAFT_SUCCESS,
  SAVE_DRAFT_ERROR,
  DELETE_DRAFT,
  DELETE_DRAFT_SUCCESS,
  DELETE_DRAFT_ERROR
} from '../constants';

const initialState = {
  data: null,
  error: null,
  loading: null,
  timestamp: null,
  loadedVersionDate: null,
  deleted: null
};

const draft = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_DRAFT:
      return {
        ...state,
        data: action.payload,
        loading: true
      };
    case LOAD_DRAFT_EMPTY:
      return {
        ...state,
        data: {},
        error: false,
        loading: false
      };
    case LOAD_DRAFT_SUCCESS:
      return {
        ...state,
        data: action.payload,
        error: false,
        loading: false,
        timestamp: action.payload.data.timestamp,
        loadedVersionDate: action.payload.data.timestamp,
        deleted: false
      };
    case LOAD_DRAFT_ERROR:
    case SAVE_DRAFT_ERROR:
      return {
        ...state,
        error: true,
        loading: false
      };
    case SAVE_DRAFT:
    case DELETE_DRAFT:
      return {
        ...state,
        loading: true
      };
    case SAVE_DRAFT_SUCCESS:
      return {
        ...state,
        error: false,
        loading: false,
        timestamp: action.payload,
        deleted: false
      };
    case DELETE_DRAFT_SUCCESS:
      return {
        ...state,
        data: {},
        error: false,
        loading: false,
        timestamp: null,
        deleted: true
      };
    case DELETE_DRAFT_ERROR:
      return {
        ...state,
        error: true,
        loading: false,
        deleted: false
      };
    default:
      return state;
  }
};

export default draft;
